import { inject, Injectable } from '@angular/core';
import { webSocket } from 'rxjs/webSocket';
import {
  Factory,
  Note,
  NoteBuilder,
  NotificationService,
  Style,
} from '@infodata-group/inf-commons';
import { ReplaySubject, retry } from 'rxjs';
import {
  WebsocketEventsType,
  WebsocketPayloadNotificationType,
} from '../types/websocket/websocket-events.type';

class NoteFactory implements Factory<Note> {
  build(o: WebsocketPayloadNotificationType): Note {
    const builder = new NoteBuilder(o.title, o.icon, o.content).setInfo(o.info);
    switch (o.style) {
      case Style.danger:
        builder.setAlertNote();
        break;
      default:
        builder.setInfoNote().setTime(o.time);
    }
    return builder.build();
  }

  getApi(): string {
    return '';
  }
}

@Injectable({
  providedIn: 'root',
})
export class WebsocketNotificationService {
  private notificationService = inject(NotificationService);

  private websocket = webSocket({
    url: 'subscribe',
    deserializer: (e) => {
      try {
        return JSON.parse(e.data);
      } catch {
        return e.data;
      }
    },
  });

  private emitter$$ = new ReplaySubject<WebsocketEventsType>();
  public emitter$ = this.emitter$$.asObservable();

  private sub = this.websocket
    .pipe(retry({ count: 10, delay: 5000, resetOnSuccess: true }))
    .subscribe({
      next: (msg) => {
        if (msg === '__ping__') {
          this.websocket.next('__pong__');
          return;
        }
        const data: WebsocketEventsType = JSON.parse(msg);
        switch (data.type) {
          case 'notification':
            this.notificationService.addNotification(
              new NoteFactory().build(data.payload),
            );
            break;
          case 'refresh':
            window.location.reload();
            break;
          default:
            this.emitter$$.next(data);
        }
      },
      error: (err) => console.log(err),
      complete: () => console.log('Socket closed'),
    });
}
